import {
  WSButton,
  WSCard,
  WSContainer,
  WSEmptyState,
  WSInfoBox,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import { getCurrentTaxPaymentQuarter } from "@wingspanhq/utils/dist/date/taxDeadlines";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React from "react";
import { useHistory } from "react-router-dom";
import { queriesTaxWithholdings } from "@query";
import { RoutePropsFromRouteHelpers } from "../../../../shared/utils/createRouteHelpers";
import {
  PATH_TAX_WITHHOLDINGS,
  routeHelpersTaxWithholdingsSchedulePaymentConfirmation
} from "../../paths";
import { Layout } from "../../../../shared/components/Layout";
import { formatInternalDeadline } from "../../utils";

const quarterInfo = getCurrentTaxPaymentQuarter();

export const ConfirmationSchedulePayment: React.FC<
  RoutePropsFromRouteHelpers<
    typeof routeHelpersTaxWithholdingsSchedulePaymentConfirmation
  >
> = () => {
  const { params, state } =
    routeHelpersTaxWithholdingsSchedulePaymentConfirmation.useData();

  const history = useHistory();

  // Prefer the amount carried over from the schedule response for an instant
  // render, but fall back to the transaction feed so the amount survives a
  // reload or a direct visit (there is no single tax-payment read on v3).
  const query =
    queriesTaxWithholdings.listTaxWithholdingTransactions.useQueryAll();
  const scheduledPayment = query.flatData?.find(
    transaction => transaction.id === params.taxPaymentId
  );

  const amount = state.amount ?? Number(scheduledPayment?.amount);

  const scheduledAmount = amount
    ? `The amount scheduled, ${formatMoney(amount, "USD")},`
    : "The scheduled amount";

  return (
    <Layout
      onClose={() => history.push(PATH_TAX_WITHHOLDINGS)}
      title={`Schedule payment to IRS - ${quarterInfo.quarter} ${quarterInfo.year}`}
      onBack={() => history.goBack()}
      wide
    >
      <WSContainer verticalPadding>
        <WSCard mt="XL">
          <WSList gap="XL">
            <WSEmptyState
              type="done"
              orientation="horizontal"
              hasBorder={false}
              title="Your payment has been scheduled"
              description={`${scheduledAmount} will be set aside from the available balance in the account to ensure your scheduled payment is sent in full to the IRS.`}
            />

            <WSInfoBox>
              <WSText.ParagraphSm color="gray500">
                No changes can be made after the processing deadline on{" "}
                <b>{formatInternalDeadline(quarterInfo.internalDeadline)}</b>.
              </WSText.ParagraphSm>
            </WSInfoBox>
          </WSList>
        </WSCard>

        <WSButton
          kind="Primary"
          fullWidth
          mt="2XL"
          onClick={() => history.push(PATH_TAX_WITHHOLDINGS)}
        >
          Back to Tax Withholdings
        </WSButton>
      </WSContainer>
    </Layout>
  );
};
